const CheckSuccess = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#333",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="50375"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M499.570547 663.289924L322.976615 486.606972a46.201513 46.201513 0 0 1 0-65.318612 46.112492 46.112492 0 0 1 65.274102 0l111.31983 111.386594L932.587325 99.41337c18.004347-18.048857 47.247501-18.048857 65.274102 0s18.026602 47.269756 0 65.318613l-498.29088 498.557941z m210.77771-521.124576a419.79727 419.79727 0 0 0-198.359385-49.806833c-231.274624 0-419.418934 188.23333-419.418934 419.641485 0 231.408154 188.14431 419.641485 419.418934 419.641485s419.396679-188.23333 419.39668-419.641485a420.620708 420.620708 0 0 0-17.715031-121.112058 46.201513 46.201513 0 0 1 30.912283-57.52934 46.246023 46.246023 0 0 1 57.484831 30.934539 512.534122 512.534122 0 0 1 21.631922 147.706859c0 282.327741-229.560984 512-511.710685 512C229.839172 1024 0.278188 794.327741 0.278188 512S229.839172 0 512.011128 0c84.435712 0 168.137008 21.031035 242.06833 60.800835a46.201513 46.201513 0 0 1-43.731201 81.364513z"
      fill={color}
      p-id="50376"
    ></path>
  </svg>
);

export default CheckSuccess;
